/**
 * Encapsulates logic to sync a viewport.
 */
export class ViewportStateMonitor {
  constructor (uScope) {
    this._uScope = uScope;

    // The last tracked state.
    this.lastState = null;

    // The current state.
    this.currentState = null;

    // Whether or not the state has changed. Use getter so we don't need to manually update.
    Object.defineProperty(this, 'hasChanged', {
      get () {
        return this.lastState !== this.currentState;
      }
    });

    // Provide a getter that computes the change in state, normalized as needed.
    Object.defineProperty(this, 'deltaState', {
      get () {
        const a = this.lastState;
        const b = this.currentState;
        const n = this._viewport.getNormalizationFactor();

        return {
          top: (b.top - a.top) / n,
          left: (b.left - a.left) / n,
          height: (b.height - a.height) / n,
          width: (b.width - a.width) / n,
          zoomRatio: (b.zoom / a.zoom),
          angleDeg: b.angleDeg - a.angleDeg
        };
      }
    });
  }

  /**
     * Updates the tracked viewport from uScope. NOTE: Stops listening to events on the original viewport.
     */
  refresh () {
    this.stop();
    this._viewport = this._uScope.getThisImage();
  }

  /**
     * Start watching the selected viewport.
     */
  start () {
    // Start listening to the viewport.
    this._listeners = [
      this._viewport.events.on('viewport:state-changed', this._update, this)
    ];

    // Capture the current state.
    this._update();

    // Sync last state to current state.
    this.clearChanges();
  }

  /**
     * Updates the current viewport state.
     */
  _update () {
    this.currentState = Object.assign({}, this._viewport.getVPView());
  }

  /**
     * Sets last state to current state, clearing any indication of state change.
     */
  clearChanges () {
    this.lastState = this.currentState;
  }

  /**
     * Stops observing viewport state changes and clears all state info.
     */
  stop () {
    if (this._listeners) {
      this._listeners.forEach((detatch) => {
        detatch();
      });
      delete this._listeners;
    }

    this.lastState = null;
    this.currentState = null;
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/manual-sync/ViewportStateMonitor.js